<template>
	<div class="content-box-wrapper login-box content-box-padding">
		<div class="content-box-header bg-gradient-17">
			<h2 class="content-box-header__headline text-white text-center">
				Logga in
			</h2>
		</div>
		<div class="content-box-wrapper content-box-padding-sm">
			<p>
				Logga in med ditt konto för att få tillgång till Målmedvetet
				näringsliv.
			</p>
			<p>
				Har du inget konto?
				<a href="#" @click.prevent="$store.commit('sidebar', 'signup')"
					>Skapa ett här.</a
				>
			</p>

			<form action="" @submit.prevent="">
				<div class="form-group">
					<label>Din mejladress</label>
					<input
						type="email"
						v-model="email"
						placeholder="Din e-mail"
						name="email"
						required
					/>
				</div>
				<div class="form-group">
					<label>Ditt lösenord</label>
					<input
						type="password"
						v-model="password"
						placeholder="Ditt lösenord"
						name="password"
						required
					/>
				</div>
				<div class="form-group margin-top-xs-2">
					<input
						type="submit"
						class="pem-btn pem-btn-primary
					pem-btn-block"
						value="Logga in"
						:class="{ 'loading loading-icon-white': isLoading }"
						@click.prevent="doLogin"
					/>
				</div>
			</form>

			<Message
				v-for="message in messages"
				:text="message.text"
				:type="message.type"
				:key="message.text"
			/>

			<div class="margin-top-xs-2">
				<div class="row justify-content-between">
					<div class="col-auto">
						<a
							href="#"
							@click.prevent="$store.commit('sidebar', 'signup')"
							>Skapa konto</a
						>
					</div>
					<div class="col text-right">
						<a
							href="#"
							@click.prevent="
								$store.commit('sidebar', 'forgot-password')
							"
							>Glömt lösenordet?</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Message from "./../partials/Message.vue";
export default {
	name: "LoginBox",
	props: [],
	components: { Message },
	computed: {
		messages() {
			return this.$store.state.messages.sidebar;
		},
		isLoading() {
			return this.$store.state.isLoading;
		}
	},
	data() {
		return {
			email: "",
			password: ""
		};
	},
	methods: {
		doLogin() {
			if (this.isLoading) return;
			this.$store.dispatch("doLogin", {
				email: this.email,
				password: this.password
			});
		}
	},
	created() {
		/* Check if user is logged in. In that case, set the email and log them in */
		if (window.pem.user != undefined) {
			this.email = window.pem.user.email;
		}
	},
	mounted() {}
};
</script>